module.exports = __webpack_public_path__ + "img/zpfu-ls3_p4.32d3132c.png";